var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 85,
    viewBox: "0 0 86 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_228)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.3866,
    y: 9.26318,
    width: 59.64,
    height: 59.64,
    rx: 29.82,
    fill: "#070A0E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6267 63.0232C56.6168 63.0232 67.1467 52.4933 67.1467 39.5032C67.1467 26.5131 56.6168 15.9832 43.6267 15.9832C30.6366 15.9832 20.1067 26.5131 20.1067 39.5032C20.1067 52.4933 30.6366 63.0232 43.6267 63.0232Z",
    fill: "#070A0E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6946 47.3893C32.9913 46.9589 32.5609 46.1945 32.5609 45.3713V40.7755C32.5609 40.2298 33.0054 39.7876 33.5511 39.79C33.7252 39.79 33.8968 39.837 34.0474 39.924L44.4173 45.971C45.0242 46.3238 45.3981 46.973 45.3981 47.6762V52.4367C45.4005 53.0905 44.8713 53.6221 44.2174 53.6221C43.9987 53.6221 43.7823 53.5609 43.5965 53.448L33.6946 47.3893ZM49.1519 38.6657C49.7587 39.0185 50.1304 39.67 50.1327 40.3709V50.0329C50.1327 50.3175 49.9798 50.581 49.7305 50.7197L47.4608 51.9969C47.4326 52.0133 47.402 52.0251 47.3691 52.0345V46.6696C47.3691 45.9757 47.0045 45.3313 46.4071 44.9738L37.3002 39.5266V33.4702C37.3002 32.9245 37.7447 32.4823 38.2904 32.4847C38.4644 32.4847 38.6361 32.5317 38.7867 32.6187L49.1519 38.6657ZM53.6913 31.5298C54.3004 31.8826 54.6744 32.5341 54.6744 33.2373V47.3493C54.6721 47.6386 54.5121 47.9044 54.2581 48.0431L52.106 49.205V39.3807C52.106 38.6869 51.7415 38.0448 51.1488 37.6873L41.8396 32.1036V26.3601C41.8396 26.186 41.8866 26.0143 41.9713 25.8638C42.2464 25.3934 42.8509 25.2335 43.3213 25.5063L53.6913 31.5298Z",
    fill: "#00D395"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_228",
    x: 0.786596,
    y: 0.0231833,
    width: 84.84,
    height: 84.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.36
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_228"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_228",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_228"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.1067,
    y: 15.9832,
    width: 47.04,
    height: 47.04,
    rx: 23.52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComp);
export default __webpack_public_path__ + "static/media/comp.2bc54fe26496950b78ce8bc83bbec96c.svg";
export { ForwardRef as ReactComponent };